import request from '@/utils/request'

export function epms9109List(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9109/epms9109List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epms9109Save
export function epms9109Save(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms9109/epms9109Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms9109Xls
export function epms9109Xls(param) {
  let data = param
  return request({
      url: `/deliveryControl/epms9109/epms9109Xls`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
  }).then(res => {
      // console.log('epms9109Xls RES', res)

      const binaryString = window.atob(res.body)
      const binaryLen = binaryString.length
      let bytes = new Uint8Array(binaryLen)

      for (let i = 0; i < binaryLen; i++) {
          let ascii = binaryString.charCodeAt(i)
          bytes[i] = ascii
      }

      const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      const blobURL = URL.createObjectURL(blob)

      const link = document.createElement('a');
      link.href = blobURL;
      link.download = `Keeping Material List.xls`;

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
  })
}